module.exports = __webpack_public_path__ + "img/acceder.db6a3c70.png";